// DesfogueNapsDialog.tsx  ← componente separado
import { gridSizeMdLg12 } from '@/shared';
import CustomAutocompleteMultipleArrDynamicSearch from '@/shared/components/ui/CustomAutocompleteMultipleArrDynamicSearch';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { Naps } from '@/shared/interfaces';
import { Grid, Typography } from '@mui/material';
import { memo, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

interface DesfogueNapsDialogProps {
  open: boolean;
  currentNap: Naps | null;
  onClose: () => void;
  onConfirm: (napsDesfogue: string[]) => Promise<void>;
  fetchNaps: (query: string, page: number) => Promise<any>;
}

export const DesfogueNapsDialog = memo(({
  open,
  currentNap,
  onClose,
  onConfirm,
  fetchNaps,
}: DesfogueNapsDialogProps) => {
  const formModal = useForm({ defaultValues: { naps_desfogue: [] as string[] } });

  // watch solo afecta a este componente, no a NapsPage
  const napsDesfogue = formModal.watch('naps_desfogue');

  useEffect(() => {
    formModal.setValue(
      'naps_desfogue',
      currentNap?.naps_desfogue || []
    );
  }, [currentNap]);

  const isEqualUnordered = (a:string[], b:string[]) => {
    if (a.length !== b.length) return false;

    const sortedA = [...a].sort();
    const sortedB = [...b].sort();

    return sortedA.every((v, i) => v === sortedB[i]);
  };

  const handleConfirm = useCallback(async () => {
    if (!currentNap) return;
    // if (!napsDesfogue.length) {
    //   toast.warning('Debe seleccionar al menos un nap para el desfogue');
    //   return;
    // }

    if(napsDesfogue?.find(nap=>nap==currentNap?.nombre)){
      toast.warning('No se puede seleccionar el mismo nap para el desfogue');
      return;
    }

    if(napsDesfogue?.find(nap=>(nap.substring(0,2)!==currentNap?.nombre?.substring(0,2)))){
      toast.warning('Las naps de desfogue deben ser de la misma nomenclatura');
      return;
    }
    
    
    if (isEqualUnordered(currentNap?.naps_desfogue || [], napsDesfogue)) {
      toast.warning('No ha cambiado la lista de naps para el desfogue');
      return;
    }
    
    await onConfirm(napsDesfogue);
  }, [currentNap, napsDesfogue, onConfirm]);

  return (
    <ScrollableDialogProps
      open={open}
      title="Realizar Desfogue"
      cancelTextBtn="Cerrar"
      confirmTextBtn="Realizar Desfogue"
      onClose={onClose}
      onConfirm={handleConfirm}
      minWidth="60%"
      contentNode={
        <Grid {...gridSizeMdLg12} item container spacing={3}>
          <Grid container item {...gridSizeMdLg12} spacing={2} rowGap={2}>
            <Grid container item {...gridSizeMdLg12}>
              <Typography>
                Registre la NAP hacia la cual se realizará el desfogue:
              </Typography>
            </Grid>
            <Grid container item {...gridSizeMdLg12}>
              <CustomAutocompleteMultipleArrDynamicSearch
                label="Naps a Realizar Desfogue"
                fetchPage={fetchNaps}
                value={napsDesfogue}
                onChangeValue={(val) => formModal.setValue('naps_desfogue', val as any)}
                filterClientSide={false}
                debounceMs={600}
              />
            </Grid>
          </Grid>
        </Grid>
      }
    />
  );
});